"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var __mapped = {
  __arr: []
};

exports["default"] = {
  unMount: function unMount() {
    __mapped = { __arr: [] };
  },
  register: function register(name, element) {
    __mapped[name] = element;
    __mapped.__arr.push(name);
  },
  unRegister: function unRegister(name) {
    var index = __mapped.__arr.indexOf(name);
    if (index >= 0) {
      __mapped.__arr.splice(__mapped.__arr.indexOf(name), 1);
      delete __mapped[name];
    }
  },
  get: function get(name) {
    return __mapped[name];
  },
  getMapped: function getMapped() {
    return __mapped;
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/rc-scroll-anim/lib/Mapped.js
// module id = 511
// module chunks = 55213770944713 173894859265406